import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { triggerBrowserDownload } from '@common/utils/download';
import { fileService } from '../services/fileService';

export function useDownload() {
  const { toast } = useToast();
  const { t } = useTranslation('files');

  return useMutation({
    mutationFn: async (fileId: string) => {
      const { downloadUrl, fileName } = await fileService.getDownloadUrl(fileId);
      triggerBrowserDownload(downloadUrl, fileName);
    },
    onError: () => {
      toast.danger({ title: t('toasts.downloadError') });
    },
  });
}
